import React, { useState, useEffect } from "react";
import {getIdData} from "../../../lib/studentpersonalanswerview"
import {updateData } from "../../../lib/studentpersonalquestion"

import { useNavigate, useParams } from 'react-router-dom';

export default function AdminStudentPersonalQuestionEdit() {

  const [answer, setAnswer] = useState();
  const [question, setQuestion] = useState();
  const [student, setStudent] = useState();
  const [studentId, setStudentId] = useState();
  const navigate = useNavigate();
  let { slug } = useParams();


  async function GetAnswer() {
    const answerdata = await getIdData(slug);
    console.log("answerdata",answerdata);
    setAnswer(answerdata[0].instructorNote);
    setQuestion(answerdata[0].pname)
    setStudent(answerdata[0].studentname + " " + answerdata[0].studentsurname)
    setStudentId(answerdata[0].studentId)
  }


  const handleSubmit = async (e) => {
      e.preventDefault();

      console.log("studentId",studentId);
 

        await updateData({
          id:slug,
          instructorNote:answer,
          instructorId:"bb780bef-49e8-4b4b-b7e3-c75d18aae7d9"
        });

        navigate(`/admin/admin-studentpersonalquestion/${studentId}`);
        
      }

  useEffect(() => {
      GetAnswer();
  }, [slug])


  return (
            <div className="col-xl-9 col-md-8">
              <div className="settings-widget profile-details">
                <div className="settings-menu p-0">
                  <div className="profile-heading">
                    <h3>Update Answer  - ({student})</h3>
                  </div>
                  <div className="checkout-form personal-address add-course-info ">
                      <div className="row mx-auto">
                        <div className="col-9">
                          <div className="form-group">
                            <label className="form-control-label">
                              Question : {question}
                            </label>
                            
                          </div>
                        </div>
                        <form method="post"  onSubmit={handleSubmit}>
                        <div className="col-9">
                          <div className="form-group"></div>
                          </div>
                        <div className="col-9">
                          <div className="form-group">
                          <label className="form-control-label">
                              Answer 
                            </label>
                            <p>
                            <textarea className="form-control" value={answer}
                              onChange={(e) => setAnswer(e.target.value)}></textarea>
                            </p>
                          </div>
                        </div>
                        <div className="update-profile d-flex justify-content-between">
                          <button type="submit"  className="btn btn-primary">
                            Update Answer
                          </button>
                          <button onClick={() => navigate(-1)} className="btn btn-black btn-sm">
                          Cancel
                          </button>
                        </div>
                        </form>
                      </div>
                  </div>
                </div>
              </div>
            </div>
  );
}
